import {
  delaersListJKC,
  sendForApproval,
} from "_controllers/officer";
import React, { useEffect, useMemo, useState } from "react";
import { toastMessage } from "utils/toastMessage";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";

const CustomProgessBar = ({ size, value, color, type }) => {
  const circumference = 2 * 115 * 3.14 * (value <= 50 ? 50 : value) * 0.01;
  return (
    <>
      <div style={{ position: "relative", margin: "0 5px" }}>
        <svg width={size} height={size} viewBox="0 0 250 250">
          <circle
            className="bg"
            cx="125"
            cy="125"
            r="115"
            fill="none"
            stroke="#ddd"
            stroke-width="20"
          ></circle>
          <circle
            className="fg"
            cx="125"
            cy="125"
            r="115"
            fill="none"
            stroke={color}
            stroke-width="20"
            stroke-dasharray={circumference}
          ></circle>
        </svg>
        <div style={{ position: "absolute", top: 6, left: 11 }}>
          {Math.trunc(value)}
        </div>
        <div style={{ fontSize: "9px", textAlign: "center" }}>{type}</div>
      </div>
    </>
  );
};

const JKCDealerTable = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  let columns = useMemo(() => [
    {
      headerName: "Dealer Code",
      flex: 1,
    },
    {
      headerName: "Name",
      flex: 1,
    },
    {
      headerName: "Email",
      flex: 1,
    },
    {
      headerName: "Phone",
      flex: 2,
    },
    {
      headerName: "Score",
      flex: 1,
    },
    // {
    //   headerName: "Details",
    //   flex: 1,
    // },
    {
      headerName: "Generate Financial Score",
      flex: 1,
    },
    {
      headerName: "Financial Profile",
      flex: 1,
    },
    // {
    //   headerName: "Send for E-contracting",
    //   flex: 1,
    // },
    {
      headerName: "Timeline",
      flex: 1,
    },
  ]);

  useEffect(async () => {
    await delaersListJKC({
      currentPage: 1,
      //   search,
      //   selectedClub,
      //   selectedDealerType,
    })
      .then((d) => {
        console.log("data1", d);
        setLoading(false);
        setData(d?.data);
      })
      .catch((err) => {
        setLoading(false);
        toastMessage("error fetching data", "error");
      });
  }, []);

  const sendToActyv = async (rowData) => {
    if (rowData?.Email1 === undefined) {
      toastMessage("Please add email address", "error");
      return;
    }
    let data = await sendForApproval({
      id: rowData._id,
      type: "JKC",
      gst: rowData?.GstNo,
      mobile: rowData?.Telf1 ?? rowData?.Mobile,
      name: rowData?.Name1,
      email: rowData?.Email1 ?? "",
    });
    if (data?.status === "failure") {
      toastMessage(data?.message, data?.status);
    } else if (data?.status === "success") {
      toastMessage("Prospect sent to Actyv", "success");
    }
  };
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          minWidth: "60%",
          overflowX: "auto",
          height: "62vh",
        }}
      >
        <Table>
          {columns && columns.length > 0 ? (
            <TableHead>
              <TableRow>
                {columns.map((item, idx) => (
                  <TableCell
                    align="left"
                    sx={{ fontWeight: "bolder" }}
                    key={idx}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          ) : null}

          <TableBody>
            {data && data?.length > 0 ? (
              data?.map((d) => (
                <TableRow key={d?._id}>
                  <TableCell align="left">{d?.Kunnr ?? "NA"}</TableCell>
                  <TableCell align="left">{d?.Name1 ?? "NA"}</TableCell>
                  <TableCell align="left">{d?.Email1 ?? "-"}</TableCell>
                  <TableCell align="left">{d?.Telf1 ?? "-"}</TableCell>
                  <TableCell align="left">
                    <div style={{ display: "flex" }}>
                      <CustomProgessBar
                        size={30}
                        value={d?.actyvScore || 0}
                        color={"#ff8a80"}
                        type="ACTYV"
                      />
                    </div>
                  </TableCell>
                  {/* <TableCell align="left">
                    <VisibilityIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOpen(true);
                        setUserData(d);
                      }}
                    />
                  </TableCell> */}
                  <TableCell align="center">
                    <Button
                      onClick={() => sendToActyv(d)}
                      variant="contained"
                      endIcon={<SendIcon />}
                      style={{ fontSize: "12px" }}
                      disabled={d?.detailSendToActyv ? true : false}
                    >
                      generate
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      disabled={
                        d?.documentLinks
                          ? d?.documentLinks.length > 0
                            ? false
                            : true
                          : true
                      }
                      onClick={() => {
                        setOpenPreview(true);
                        setProspectInfo(d);
                      }}
                    >
                      Preview
                    </Button>
                  </TableCell>
                  {/* <TableCell align="center">
                    <Button
                      onClick={() => handleButtonClick3(d)}
                      variant="contained"
                      disabled={true}
                      endIcon={<SendIcon />}
                      style={{ fontSize: "12px" }}
                    >
                      send
                    </Button>
                  </TableCell> */}
                  <TableCell align="left">
                    <IconButton
                      size="large"
                      color="primary"
                      disabled={true}
                      onClick={() => {
                        // setOpenTimeline(true);
                        // setProspectId1(d?._id);
                      }}
                    >
                      <RemoveRedEyeIcon fontSize="inherit" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <Box sx={{ textAlign: "left", pt: 1 }}>
                <Typography variant="h6" sx={{ p: 1 }}>
                  No Data.
                </Typography>
              </Box>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default JKCDealerTable;
